import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslationContext } from "../../hooks/translations/translationsProvider";
import { GREEN_LOGO, GREEN_MAIN } from "../../theme/colors";
import { Trans } from "react-i18next";
import { useUserContext } from "../../hooks/auth/UserProvider";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const FidelityPoints:React.FC = () =>{
    const {isForbidden} = useUserContext();
    const {t} = useTranslationContext();
    const navigate = useNavigate();

    useEffect(() => {
        if(isForbidden){
            navigate('/');
        }
    }, [isForbidden]);

    return(
        !isForbidden ?
        <Box sx={{width:'100%', overflow: 'hidden', maxWidth: '100%', fontFamily:'poppins', color:GREEN_MAIN }}>
            <Typography variant="h5" paddingBottom={5}>
                {t("Come Funziona")}
            </Typography>
            <Typography fontSize='0.9em' textAlign='justify' paddingBottom={3}>
                {t('Punti_fedelta_how')}
            </Typography>
            <Typography fontSize='0.9em' textAlign='start'  paddingBottom={3}>
                {t("Riassumendo")}:
            </Typography>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{
                        backgroundColor: `${GREEN_LOGO}20`
                    }}>
                        <TableRow>
                            <TableCell sx={{textAlign:'left', color:`${GREEN_LOGO}`, width:'50%', padding:'2px 16px'}}>{t("Operazione")}</TableCell>
                            <TableCell sx={{textAlign:'center', color:`${GREEN_LOGO}`, width: '25%', padding:'2px 16px'}}>{t("Bonus")}</TableCell>
                            <TableCell sx={{textAlign:'center', color:`${GREEN_LOGO}`, width: '25%', padding:'2px 16px'}}>{t("Punti fedeltà")}</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '20px 5px 5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >{t("Presentazione Associazione")}</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '20px 5px 5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px', 
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >10 ASSO</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '20px 5px 5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >40</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >{t("Presentazione Attività economica")}</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px', 
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >10 ASSO</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >40</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >{t("Acquisto ASSO")}</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px', 
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >-</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >1 : 1 *</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >{t("Acquisti su Assobay")}</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px', 
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >-</TableCell>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    padding: '5px 5px', 
                                    color: GREEN_MAIN,
                                    fontWeight:'bold',
                                    letterSpacing:'1px',
                                    textAlign:'center',
                                    fontSize:'15px',
                                    lineHeight:'1em'
                                }}
                            >10 : 1 **</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <Typography fontSize='0.8em' textAlign='left' paddingTop={3} fontStyle='italic'>
                * <Trans i18nKey="fino ad un massimo di punti fedeltà al mese" values={{ count: 150 }} />
            </Typography>
            <Typography fontSize='0.8em' textAlign='left' paddingBottom={5} fontStyle='italic'>
                ** <Trans i18nKey="fino ad un massimo di punti fedeltà al mese" values={{ count: 15 }} />
            </Typography>

            <Typography fontSize='0.9em' textAlign='justify' paddingBottom={1}>
                <Trans
                    i18nKey = "punti-fedelta"
                    components = {{
                        strong : (
                            <strong></strong>
                        )
                    }} 
                />
            </Typography>
            <Typography fontSize='0.9em' textAlign='justify' paddingBottom={1}>
                {t("punti-fedelta-sub")}
            </Typography>

            <Typography
                variant="body1"
                paragraph
                sx={{
                    fontSize: '0.9em',
                    display: "flex",
                    alignItems: "top",
                    textAlign:'justify',
                    marginBottom:'0px'
                }}
                >
                <Box component="span" sx={{ mr: 1, color: "darkgreen" }}>
                    ▸
                </Box>
                {t("punti-fedeltà-punto-1")}
            </Typography>
            <Typography
                variant="body1"
                paragraph
                sx={{
                    fontSize: '0.9em',
                    display: "flex",
                    alignItems: "top",
                    textAlign:'justify',
                }}
                >
                <Box component="span" sx={{ mr: 1, color: "darkgreen" }}>
                    ▸
                </Box>
                {t("punti-fedeltà-punto-2")}
            </Typography>

        </Box>
        : <></>
    );
}